var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 36.9642C26.984 36.9642 33.3419 29.9176 33.3419 21.2253C33.3419 12.5329 26.984 5.48633 19.1412 5.48633C11.2983 5.48633 4.94043 12.5329 4.94043 21.2253C4.94043 29.9176 11.2983 36.9642 19.1412 36.9642Z",
    stroke: "#717070",
    strokeWidth: 2.52458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2911 25.1582C24.6673 26.3541 23.7706 27.347 22.691 28.0373C21.6114 28.7276 20.387 29.091 19.1407 29.091C17.8943 29.0911 16.6699 28.7277 15.5904 28.0374C14.5108 27.3471 13.6141 26.3542 12.9902 25.1583",
    stroke: "#717070",
    strokeWidth: 2.52458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8151 19.9113C14.7955 19.9113 15.5902 19.0305 15.5902 17.9439C15.5902 16.8574 14.7955 15.9766 13.8151 15.9766C12.8348 15.9766 12.04 16.8574 12.04 17.9439C12.04 19.0305 12.8348 19.9113 13.8151 19.9113Z",
    fill: "#717070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4665 19.9113C25.4469 19.9113 26.2416 19.0305 26.2416 17.9439C26.2416 16.8574 25.4469 15.9766 24.4665 15.9766C23.4861 15.9766 22.6914 16.8574 22.6914 17.9439C22.6914 19.0305 23.4861 19.9113 24.4665 19.9113Z",
    fill: "#717070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyIcon);
export default __webpack_public_path__ + "static/media/SmileyIcon.54713b2c798eee8b6f45e2f494aaab44.svg";
export { ForwardRef as ReactComponent };